import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ReactComponent as EditIcon } from "images/profile/edit-icon.svg";

function ExperienceDisplay({ onEditClick = () => {}, isShowEditIcon = false }) {
  const [t] = useTranslation();
  const userDetails = useSelector((state) => state.userDetails || {});

  const userDomains = useSelector((state) => state.userDomains || []);
  const userSubDomains = useSelector((state) => state.userSubDomains || []);
  const [isEditShowEditOnHover, setShowEditOnHover] = useState(false);

  return (
    <div
      id="experienceSection"
      className={`flex p-[24px] flex-col gap-[12px] self-stretch ${
        isEditShowEditOnHover ? " cursor-pointer bg-[#F3F5F7]" : ""
      }`}
      onMouseEnter={() => setShowEditOnHover(true)}
      onMouseLeave={() => setShowEditOnHover(false)}
    >
      <div className={`flex ${"justify-between"} items-center self-stretch`}>
        <div className="flex flex-wrap items-center gap-[10px] w-full">
          <div className="text-[#1D1B22] font-semibold text-[24px]">
            {t("experience")}
          </div>
          <div className="flex p-[10px] items-center justify-center rounded-[6px] bg-[#E0E6EB]">
            <div className="text-gray-800 text-center font-semibold text-[14px]">{`${
              Number.isNaN(Number(`${userDetails.yearOfExperience}`))
                ? "-"
                : userDetails.yearOfExperience
            } ${t("years")}`}</div>
          </div>

          <div className="flex p-[10px] items-center justify-center rounded-[6px] bg-[#E0E6EB]">
            <div className="text-gray-800 text-center font-semibold text-[14px]">
              {t("isWillingToTravel", {
                isWillingToTravel: userDetails?.isWillingToTravel ? "" : "not",
              })}
            </div>
          </div>

          <div className="flex p-[10px] items-center justify-center rounded-[6px] bg-[#E0E6EB]">
            <div className="text-gray-800 text-center font-semibold text-[14px]">
              {`${t("openForSecondment")}: ${
                userDetails?.isOpenForSecondment ? t("Yes") : t("No")
              }`}
            </div>
          </div>
        </div>
        {isShowEditIcon && (
          <EditIcon
            className={`cursor-pointer ${
              isEditShowEditOnHover ? "visible" : "invisible"
            }`}
            onClick={onEditClick}
          />
        )}
      </div>

      <div className="flex flex-wrap gap-[20px]">
        {userDomains.map((domain) => {
          const domainSubDomains = userSubDomains.filter(
            (subDomain) => subDomain.domainId === domain.id
          );

          if (domainSubDomains.length === 0) return null;

          return (
            <div
              key={domain.id}
              className="flex flex-col gap-[12px] py-[10px] px-[16px] border border-[#E0E6EB] rounded-[8px] min-w-[280px]"
            >
              <h3 className="text-[#1D1B22] font-semibold text-[18px]">
                {domain.title}
              </h3>
              <div className="flex flex-wrap gap-[8px]">
                {domainSubDomains.map((subDomain) => (
                  <span
                    key={subDomain.id}
                    className="flex py-[4px] px-[8px] justify-center items-center gap-[2px] rounded-[6px] bg-[#E0E6EB]"
                  >
                    <span className="text-[#1E4A6B] font-semibold text-[14px]">
                      {`${subDomain.title}${
                        domain?.customDomain ? ` (${domain?.customDomain})` : ""
                      }`}
                    </span>
                  </span>
                ))}
              </div>
            </div>
          );
        })}

      </div>

      {userDetails?.hasCatToolsExperience && userDetails?.catTools?.length > 0 && (
        <div className="flex flex-col gap-[12px] py-[10px] px-[16px] border border-[#E0E6EB] rounded-[8px] min-w-[280px] w-fit">
          <h3 className="text-[#1D1B22] font-semibold text-[18px]">
            {t("catToolsLabel")}
          </h3>
          <div className="flex flex-wrap gap-[8px]">
            {userDetails.catTools.map((tool, index) => (
              <span
                key={`cat-tool-${index}`}
                className="flex py-[4px] px-[8px] justify-center items-center gap-[2px] rounded-[6px] bg-[#E0E6EB]"
              >
                <span className="text-[#1E4A6B] font-semibold text-[14px]">
                  {tool}
                </span>
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

ExperienceDisplay.propTypes = {
  onEditClick: PropTypes.func.isRequired,
  isShowEditIcon: PropTypes.bool,
};

export default ExperienceDisplay;
